<template>
  <vs-sidebar default-index="1" :parent="parent" :hiddenBackground="$store.getters['IS_SIDEBAR_ACTIVE']"
    class="sidebarx" spacer v-model="$store.getters['IS_SIDEBAR_ACTIVE']"
    :click-not-close="$store.getters['IS_SIDEBAR_ACTIVE']">
    <div :key="indextr" v-for="(tr, indextr) in users_item">
      <vs-sidebar-group v-if="[tr.user].includes(username)" open title="Dashboard">
        <vs-sidebar-item icon="dashboard" :to="tr.path" index="2">
          Dashboard {{ tr.name }}
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/report'" index="2" icon="description">
          Report
        </vs-sidebar-item>
      </vs-sidebar-group>
    </div>
    <div v-if="username.match('frasers') || username == 'Galaxy'">
      <vs-sidebar-group title="Overview" open>
        <vs-sidebar-item icon="map" to="/mapOverview" key="sidebarLink-100">
          Map Overview
        </vs-sidebar-item>
        <vs-sidebar-group title="Dashboard">
          <vs-sidebar-item icon="dashboard" to="/customdashboard" index="1">
            Dashboard Kendall
          </vs-sidebar-item>
          <vs-sidebar-item icon="dashboard" to="/customdashboardRojana" index="2">
            Dashboard Endeavor
          </vs-sidebar-item>
          <vs-sidebar-item icon="dashboard" to="/customdashboardBangplee" index="3">
            Dashboard Unicorn
          </vs-sidebar-item>
          <vs-sidebar-item icon="dashboard" to="/customdashboardJasperW1" index="4">
            Dashboard Jasper W1
          </vs-sidebar-item>
          <vs-sidebar-item icon="dashboard" to="/customdashboardJasperW3" index="5">
            Dashboard Jasper W3
          </vs-sidebar-item>
          <vs-sidebar-item icon="dashboard" to="/customdashboardYellowW3" index="3">
            Dashboard YW3
          </vs-sidebar-item>
          <vs-sidebar-item icon="dashboard" to="/customdashboardgarnett" index="3">
            Dashboard Garnett
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>
      <!-- <vs-sidebar-group title="Power consumption">
        <vs-sidebar-item icon="dashboard" to="/FraserPowerconsumption" index="1">
          Dashboard Kendall
        </vs-sidebar-item>
        <vs-sidebar-group title="Dashboard" open>
          <vs-sidebar-item :to="'/Machinelist/UM'" icon="corporate_fare">
            UM Building
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group> -->

      <vs-sidebar-item icon="show_chart" to="/graph" key="sidebarLink-100">
        Graph Visualization
      </vs-sidebar-item>
      <vs-sidebar-group title="Sentenance" open>
        <vs-sidebar-item :to="'/overview'" index="1" icon="cloud_queue">
          Overview
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/report'" index="2" icon="description">
          Report
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/location'" index="3" icon="room">
          location
        </vs-sidebar-item>
        <vs-sidebar-group title="Device Mangement">
          <vs-sidebar-item :to="'/sensor'" index="2.1" icon="signal_cellular_alt">
            Device
          </vs-sidebar-item>
          <vs-sidebar-item :to="'/gateway'" index="2.2" icon="settings_remote">
            Gateway
          </vs-sidebar-item>
          <vs-sidebar-item :to="'/Alert'" index="2.3" icon="report_problem">
            Alert
          </vs-sidebar-item>
        </vs-sidebar-group>
        <vs-sidebar-group title="Setting">
          <vs-sidebar-item :to="'/action'" index="2.1" icon="new_releases">
            Alert Setting
          </vs-sidebar-item>
          <vs-sidebar-item :to="'/network'" index="2.2" icon="wifi">
            Network
          </vs-sidebar-item>
          <vs-sidebar-item :to="'/user'" index="2.3" icon="person">
            User
          </vs-sidebar-item>
          <vs-sidebar-item :to="'/locationsetting'" index="2.3" icon="explore">
            Location Setting
          </vs-sidebar-item>
        </vs-sidebar-group>
      </vs-sidebar-group>
    </div>
    <footer-sidebar slot="footer"></footer-sidebar>
  </vs-sidebar>
</template>
<script>
import FooterSidebar from "../FooterSidebar.vue";
export default {
  name: "BetagroSidebar",
  components: {
    FooterSidebar,
  },
  data() {
    return {
      username: "",
      users_item: [
        {
          id: 1,
          name: "Kendall",
          path: "/customdashboard",
          user: "Kendell",
        },
        {
          id: 2,
          name: "Endeavor",
          path: "/customdashboardRojana",
          user: "Endeavor",
        },
        {
          id: 3,
          name: "Unicorn",
          path: "/customdashboardBangplee",
          user: "Unicorn",
        },
        {
          id: 4,
          name: "Jasper W3",
          path: "/customdashboardJasperW3",
          user: "JasperW3",
        },
        {
          id: 5,
          name: "Jasper W1",
          path: "/customdashboardJasperW1",
          user: "JasperW1",
        },
        {
          id: 6,
          name: "Yellow W3",
          path: "/customdashboardYellowW3",
          user: "Ywood31",
        },
        {
          id: 7,
          name: "Yellow W3",
          path: "/customdashboardYellowW3",
          user: "Ywood32",
        },
        {
          id: 8,
          name: "Yellow W3",
          path: "/customdashboardYellowW3",
          user: "Ywood33",
        },
        {
          id: 9,
          name: "Yellow W3",
          path: "/customdashboardYellowW3",
          user: "Ywood34",
        },
        {
          id: 10,
          name: "Garnett",
          path: "/customdashboardgarnett",
          user: "Garnet",
        },
      ],
    };
  },
  mounted() {
    this.username = this.$session.get("username");
  },
};
</script>

<style>

</style>